import { GatewayAPIService } from '../../core/gateway-api.service';
import { Attachment } from './attachment';
import { Injectable } from '@angular/core';
import { FileUpload } from './fileUpload';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  options = {
    authenticate: true,
    setRoot: true,
    updateAuthHeader: false,
    returnAsUrl: false,
  };

  constructor(private api: GatewayAPIService) {}

  public getMerchantAttachments(merchantId: string): Promise<Attachment[]> {
    return this.get({ merchantId: merchantId });
  }
  public getLeadAttachments(leadId: string): Promise<Attachment[]> {
    return this.get({ leadId: leadId });
  }

  public deleteMerchantAttachment(
    merchantId: string,
    attachmentId: string,
  ): Promise<void> {
    return this.api.apiCallSane(
      `/document`,
      'DELETE',
      this.api.getDefaultHeaders(),
      { merchantId: merchantId, id: attachmentId },
      null,
      this.options,
    );
  }

  public uploadMerchantAttachments(
    merchantId: string,
    attachments: FileUpload[],
  ): Promise<void> {
    let formData = new FormData();
    let metaData: { type: string | undefined; otherType: string | undefined; notes: string | undefined }[] = [];

    for (var i = 0; i < attachments.length; i++) {
      formData.append('files', attachments[i].file);

      metaData.push({
        type: attachments[i].type,
        otherType: attachments[i].otherType,
        notes: attachments[i].notes,
      });
    }

    formData.append('merchantId', merchantId);
    formData.append('metadata', JSON.stringify(metaData));

    return this.api.apiCallSane(
      '/documents',
      'POST',
      this.api.getMultipartHeaders(),
      null,
      formData,
      this.options,
    );
  }

  private get(data: any): Promise<Attachment[]> {
    return this.api
      .apiCallSane(
        '/documents',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((response: Partial<Attachment>[]) =>
        response.map((a) => new Attachment(a)),
      );
  }

  async openAttachment(
    id: string,
    merchantId: string,
    downloadName: string,
    newWindow: boolean = false,
  ) {
    this.options.returnAsUrl = true;

    await this.api
      .openFile(
        '/document',
        'GET',
        this.api.getDefaultHeaders(),
        { id: id, merchantId: merchantId },
        null,
        this.options,
      )
      .then((fileURL) => {
        let url = fileURL as string;

        if (newWindow) {
          let newTab = window.open();

          if (newTab) {
            /*
                    If the file is a PDF, we will let the browser handle its display and download.
                    Otherwise, we'll style the page with an inline display and a download button.
                    */

            if (downloadName.endsWith('.pdf')) {
              newTab.document.write(`
                            <html>
                            <head>
                                <title>File Preview</title>
                            </head>
                            <body style="margin:0; padding:0;">
                                <iframe src="${url}" style="width:100%; height:100vh; border:none;"></iframe>
                            </body>
                            </html>
                        `);
            } else {
              // Write HTML content to the new tab
              newTab.document.write(`
                    <html>
                        <head>
                        <title>File Preview</title>
                        </head>
                        <body style="margin:0; padding:0;">
                            <div style="width:100%; padding:10px; background-color:#444444;">
                                <button onclick="downloadFile()" style="display:block; text-align:center; border:1px solid #dddddd; background-color:transparent; color:white; cursor:pointer;" title="Download">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                                </button>
                            </div>
                            <div style="padding:10px;">
                                <iframe src="${url}" style="width:100%; height:100vh; border:none;"></iframe>
                            </div>

                            <script>
                            function downloadFile() {
                                const link = document.createElement("a");
                                link.href = "${url}";
                                link.download = "${downloadName}";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            };
                            </script>                        
                        </body>
                    </html>
                    `);
            }
            newTab.document.close(); // Ensure the document is finished loading
          } else {
            alert('Pop-ups are blocked. Please allow pop-ups for this site.');
          }
        } else {
          // Create an anchor element
          const a = document.createElement('a');
          a.href = url;
          a.target = '_blank'; // Opens the file in a new tab (optional)
          a.download = downloadName; // Adjust filename and extension
          a.click();
          // Clean up the object URL after the download starts
          URL.revokeObjectURL(url);
        }
      });
  }
}
